export default {
  data() {
    return {
      isSectionLoading: false,
      isActionPending: false,
      sectionLoadingCount: 0,
    };
  },
  methods: {
    async withSectionLoading(request) {
      this.sectionLoadingCount += 1;
      this.isSectionLoading = true;
      try {
        return await request();
      } finally {
        this.sectionLoadingCount = Math.max(0, this.sectionLoadingCount - 1);
        this.isSectionLoading = this.sectionLoadingCount > 0;
      }
    },
    async withAction(request) {
      if (this.isActionPending) {
        return;
      }

      this.isActionPending = true;
      try {
        return await request();
      } finally {
        this.isActionPending = false;
      }
    },
  },
};
